import { type AcceptedLang, getLang } from '@lingoda/env';
import { useConfigurationQuery } from '@lingoda/graphql';

export const useCurrentLocale = (): { code: AcceptedLang; label: string } => {
    const { data } = useConfigurationQuery();
    const supportedLangs: Record<AcceptedLang, string> = data?.config.languages || {};
    const currentLangCode = getLang();
    const currentLangLabel: string | undefined = supportedLangs[currentLangCode];

    if (currentLangLabel) {
        return {
            code: currentLangCode,
            label: currentLangLabel,
        };
    }

    return {
        code: 'en',
        label: 'English',
    };
};
